import request from '../utils/request';

/**
 * 获取店铺列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页数量
 * @returns {Promise}
 */
export const getStores = (params) => {
  return request.get('/stores', { params });
};

/**
 * 获取店铺详情
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const getStoreById = (id) => {
  return request.get(`/stores/${id}`);
};

/**
 * 创建店铺
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
  export const createStore = (data, id) => {
    const newData = { ...data, master_id: id };
    return request.post('/stores', newData);
  };

/**
 * 更新店铺
 * @param {number} id - 店铺ID
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
export const updateStore = (id, data) => {
  return request.put(`/stores/${id}`, data);
};

/**
 * 删除店铺
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const deleteStore = (id) => {
  return request.delete(`/stores/${id}`);
};

export const visibleStore = async (user_id) => {
  return await request({
    url: `/stores/visible?user_id=${user_id}`,
    method: 'get',
  })
};

/**
 * 获取店铺可见用户
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const visibleUser = async (id) => {
  return await request({
    url: `/stores/${id}/users`,
    method: 'get',
  })
}

export const batchSetStorePermissions = async (data) => {
  return await request({
    url: '/stores/permission',
    method: 'post',
    data: data,
  })
}